import React from "react";
import { Flex, FormControl, FormLabel, Input, Select, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { OWNER_TYPE_FILTER_OPTIONS } from "./subscriptionsManageConstants";

const OWNER_TYPE_OPTIONS = OWNER_TYPE_FILTER_OPTIONS.filter((opt) => opt.value !== "");

/**
 * Returns the initial owner picker state.
 * @returns {{owner_type: string, owner_id: string}}
 */
export function buildOwnerInitialState() {
    return { owner_type: "user", owner_id: "" };
}

/**
 * Validates the owner picker state. Returns null on success, an error message otherwise.
 * @param {Object} owner - Owner state
 * @returns {string|null}
 */
export function validateOwner(owner) {
    if (!owner.owner_type) return "Sélectionne un type de propriétaire";
    const id = Number(String(owner.owner_id).trim());
    if (!Number.isInteger(id) || id < 1) return "L'ID du propriétaire doit être un entier positif";
    return null;
}

/**
 * Owner picker section: owner_type Select + owner_id number field.
 * Wrapped in a teal-tinted box to visually mark it as the recipient block.
 * @param {Object} props
 * @param {Object} props.owner - Owner state
 * @param {Function} props.setOwner - Owner state setter
 * @returns {React.ReactElement}
 */
function OwnerPicker({ owner, setOwner }) {
    const labelColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    const wrapBg = useColorModeValue("brand.50", "whiteAlpha.100");
    const update = (key, value) => setOwner({ ...owner, [key]: value });
    return (
        <Stack spacing="12px" mb="16px" p="12px" borderRadius="12px" bg={wrapBg}>
            <Text color={labelColor} fontSize="0.7rem" textTransform="uppercase" letterSpacing="0.5px" fontWeight="700">Propriétaire</Text>
            <Flex direction={{ base: "column", sm: "row" }} gap="12px">
                <FormControl minW="180px">
                    <Select size="sm" borderRadius="8px" value={owner.owner_type} onChange={(e) => update("owner_type", e.target.value)}>
                        {OWNER_TYPE_OPTIONS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                    </Select>
                </FormControl>
                <FormControl>
                    <FormLabel fontSize="0.75rem" mb="2px">ID propriétaire</FormLabel>
                    <Input size="sm" borderRadius="8px" type="number" min={1} step={1}
                        value={owner.owner_id} onChange={(e) => update("owner_id", e.target.value)} />
                </FormControl>
            </Flex>
        </Stack>
    );
}

export default OwnerPicker;
